module.exports = __webpack_public_path__ + "img/m08.e4a40023.png";